<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<div class="modal-body modal-body-grid-ht" [hidden]="minimise">
  <p class="confirm-prompt">The data you are replacing is shown below. Are you sure you want to proceed?</p>
  @if (gridData && gridData.length > 0) {
<div class="scrubbing-grid-container">
    <table class="scrubbing-table">
      <thead>
        <tr>
          @for (col of gridColumns; track $index) {
<th>{{ col }}</th>
}
        </tr>
      </thead>
      <tbody>
        @for (row of gridData; track $index) {
<tr>
          @for (col of gridColumns; track $index) {
<td>
            {{ (row?.data != null ? row.data : row)[col] }}
          </td>
}
        </tr>
}
      </tbody>
    </table>
  </div>
}
  @if (!gridData?.length) {
<div class="no-grid-data">
    <p>No data to display.</p>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="confirm()">Yes</button>
  <button class="cancel-button" type="button" (click)="cancel()">No</button>
</div>
